<template>
	<div class="daohang">
		<div class="pc-width">
			<img class="logo" @click="tiaozhuan(0)" src="../assets/logo.png" alt="logo">
			<div class="fenlei">
				<div class="li" v-for="(item,index) in tabList" :key="index" @click="tiaozhuan(index)">
					<div :class="{text:index==tabIndex}">{{item.name}}</div>
					<div v-if="index==tabIndex" class="selected"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'daohang',
		props: {
			tabIndex: {
				type: Number,
				default: 0
			}
		},
		data() {
			return {
				tabList: [{
					name: '首页'
				}, {
					name: '关于我们'
				}, {
					name: '联系我们'
				}]
			}
		},
		methods: {
			tiaozhuan(index) {
				this.$emit('selected', index)
				localStorage.setItem('index', index)
			}
		}
	}
</script>

<style lang="less" scoped>
	.daohang {
		padding: 10px 0;

		.pc-width {
			display: flex;
			align-items: center;
			justify-content: space-between;

			.logo {
				width: 90px;
				height: 90px;
				cursor: pointer;
			}

			.fenlei {
				display: flex;

				.li {
					position: relative;
					margin-left: 40px;

					font-size: 18rpx;
					color: #333333;
					cursor: pointer;

					.text {
						color: #FF2021;
					}

					.selected {
						width: 100%;
						height: 3px;
						border-radius: 50px;
						background-color: #FF2021;
						margin-top: 5px;
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/daohang.vue